export const SearchResultsPageTestIds = {
  collectionSelectDrawer: 'collection-select-drawer',
  collectionSelectOption: 'collection-select-option',
  vipAdsSection: 'vip-ads-section',
  latestAdsSection: 'latest-ads-section',
  inlineFilters: {
    container: 'inline-filters-container',
    price: 'inline-price-filter',
    region: 'inline-region-filter',
    sort: 'inline-sort',
    sortBottomSheet: 'inline-sort-bottom-sheet',
    priceBottomSheet: 'inline-price-bottom-sheet',
    regionDrawer: 'inline-region-drawer',
    regionOption: 'inline-region-option',
    sellerType: 'inline-seller-type-filter',
    sellerTypeBottomSheet: 'inline-seller-type-bottom-sheet',
    sellerTypeOption: 'inline-seller-type-filter-option',
  },
  desktopFilters: {
    container: 'desktop-filters-container',
    header: 'desktop-filters-header',
    headerTitle: 'desktop-filters-header-title',
    resetButton: 'desktop-filters-reset-button',
    categories: 'desktop-categories-filter',
    category: 'desktop-filters-category',
    currentCategory: 'desktop-filters-current-category',
    parentCategory: 'desktop-filters-parent-category',
    price: 'desktop-price-filter',
    region: 'desktop-region-filter',
    regionOption: 'desktop-region-filter-option',
    clearButton: 'desktop-filter-clear-button',
    booleanOption: 'desktop-filter-boolean-button',
    sellerType: 'desktop-seller-type-filter',
    sellerTypeOption: 'desktop-seller-type-filter-option',
  },
};
